export enum SURVEY_STREAM_LOADING_STATUS {
  COMPLETED = 'completed',
  LOADING   = 'loading'
}
